import axios from "axios";
import router from "@/router";
import api from "@/api";

export const marketingCertificatesModule = {
    namespaced: true,

    state: () => ({
        isLoading: true,
        certificates: null,
        excelData: null
    }),

    mutations: {
        setCertificates(state, data) {
            state.certificates = data
        },
        setExcelData(state, data) {
            state.excelData = data;
        },
    },

    actions: {
        async getCertificates({ state, commit }) {
            state.isLoading = true;

            // получаем параметры из текущего route
            const currentRoute = router.currentRoute.value;
            const params = { ...currentRoute.query };

            return axios
                .get(`${api}projects/tcode/certificates/`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    },
                    params: params
                })
                .then((response) => {
                    commit('setCertificates', response.data.results);
                    commit("setExcelData", response.data.results);
                    state.isLoading = false;
                    return response;
                })
                .catch((error) => {
                    console.log(error);
                    state.isLoading = false;
                });
        },

        async getExcelFile({ state }) {
            try {
                const response = await axios.post(
                    api + "reports/export_to_excel/",
                    state.excelData,
                    {
                        headers: {
                            Authorization: "Token " + localStorage.getItem("token"),
                        },
                        responseType: "blob",
                    }
                );
                const now = new Date();
                const url = URL.createObjectURL(response.data);
                const a = document.createElement("a");
                a.href = url;
                a.download = `Сертификаты_${now.toLocaleDateString()}.xls`;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            } catch (err) {
                // Если есть ошибка
                alert(err);
            }
        },
    },
};
